module.exports = __webpack_public_path__ + "ef42c48bb775d61cddfc08d35c6e1065.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-1024.jpg
// module id = 369
// module chunks = 0